import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, GraduationCap, CheckCircle, Clock, ExternalLink, Mail, Phone, Users, Calendar, Award, Snowflake, Zap, Target } from 'lucide-react';
import { Button } from '../components/ui/button';
import { SEO } from '../components/SEO';

import i18n from '../i18n';
import { useTranslation } from 'react-i18next';
const t = (k, o) => i18n.t(k, o);

const SignupUrl = 'https://app.hoopit.io/join/veitvet-sportsklubb-532465/open/veitvet-fotballakademi-13-16-ar-202627-510222';

const getPeriodPlan = () => [
  { num: '1', title: t('pg.UngdomsakademiPage.663195'), weeks: t('pg.UngdomsakademiPage.e4d6b6'), desc: t('pg.UngdomsakademiPage.9a403c') },
  { num: '2', title: t('pg.UngdomsakademiPage.4281f8'), weeks: t('pg.UngdomsakademiPage.7739c0'), desc: t('pg.UngdomsakademiPage.d0f430') },
  { num: '3', title: t('pg.UngdomsakademiPage.fd3f3b'), weeks: t('pg.UngdomsakademiPage.2f3bc2'), desc: t('pg.UngdomsakademiPage.d08099') },
  { num: '4', title: t('pg.UngdomsakademiPage.0470aa'), weeks: t('pg.UngdomsakademiPage.e9dc57'), desc: t('pg.UngdomsakademiPage.7bedd5') },
  { num: '5', title: t('pg.UngdomsakademiPage.6d0f8d'), weeks: t('pg.UngdomsakademiPage.b14467'), desc: t('pg.UngdomsakademiPage.2bfa23') },
  { num: '6', title: t('pg.UngdomsakademiPage.d63133'), weeks: t('pg.UngdomsakademiPage.c18fd4'), desc: t('pg.UngdomsakademiPage.1b9c2e') },
];

export const UngdomsakademiPage = () => {
  useTranslation();
  return (
    <div data-testid="ungdomsakademi-page" className="min-h-screen py-12 px-4 sm:px-6 lg:px-8">
      <SEO
        title={t('pg.UngdomsakademiPage.02a68b')}
        description={t('pg.UngdomsakademiPage.25581e')}
      />
      <div className="max-w-4xl mx-auto">
        <Link to="/soccer" className="inline-flex items-center gap-2 text-slate-500 hover:text-green-500 transition-colors mb-8">
          <ArrowLeft className="w-4 h-4" />
          {t('pg.UngdomsakademiPage.1cfcac')}
        </Link>

        {/* Hero */}
        <div className="bg-gradient-to-r from-green-500/20 to-transparent rounded-2xl p-8 border border-green-500/30 mb-8">
          <div className="flex items-start gap-4">
            <div className="w-14 h-14 bg-green-500/20 rounded-xl flex items-center justify-center flex-shrink-0">
              <GraduationCap className="w-8 h-8 text-green-500" />
            </div>
            <div>
              <p className="text-green-500 font-medium uppercase tracking-widest text-xs mb-1">{t('pg.UngdomsakademiPage.339433')}</p>
              <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 dark:text-white mb-3">{t('pg.UngdomsakademiPage.0a305b')}</h1>
              <p className="text-lg text-slate-600 dark:text-slate-300 mb-3">
                {t('pg.UngdomsakademiPage.05466f')} <strong className="text-green-500">{t('pg.UngdomsakademiPage.5742df')}</strong>.
              </p>
              <p className="text-slate-600 dark:text-slate-300">
                {t('pg.UngdomsakademiPage.20c0ce')}
              </p>
            </div>
          </div>
        </div>

        {/* Hvorfor velge */}
        <section className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-8 mb-6">
          <h2 className="text-2xl font-bold text-slate-900 dark:text-white mb-6">{t('pg.UngdomsakademiPage.1a2d70')}</h2>

          <div className="space-y-6">
            <div>
              <h3 className="text-lg font-bold text-slate-900 dark:text-white mb-2 flex items-center gap-2">
                <Target className="w-5 h-5 text-green-500" /> {t('pg.UngdomsakademiPage.4bd07b')}
              </h3>
              <p className="text-slate-600 dark:text-slate-300 mb-3">{t('pg.UngdomsakademiPage.a8d39a')}</p>
              <ul className="space-y-2">
                {[t('pg.UngdomsakademiPage.3a2d5d'), t('pg.UngdomsakademiPage.b37c78'), t('pg.UngdomsakademiPage.843705'), t('pg.UngdomsakademiPage.ceec7f')].map(item => (
                  <li key={item} className="flex items-start gap-2 text-slate-600 dark:text-slate-300">
                    <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-bold text-slate-900 dark:text-white mb-2">{t('pg.UngdomsakademiPage.1c1779')}</h3>
              <p className="text-slate-600 dark:text-slate-300 mb-3">{t('pg.UngdomsakademiPage.1648b4')}</p>
              <ul className="space-y-2">
                {[t('pg.UngdomsakademiPage.b58a00'), t('pg.UngdomsakademiPage.00468a'), t('pg.UngdomsakademiPage.0daff3')].map(item => (
                  <li key={item} className="flex items-start gap-2 text-slate-600 dark:text-slate-300">
                    <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-bold text-slate-900 dark:text-white mb-2">{t('pg.UngdomsakademiPage.3eb6ae')}</h3>
              <p className="text-slate-600 dark:text-slate-300 mb-3">{t('pg.UngdomsakademiPage.61a1b7')}</p>
              <ul className="space-y-2">
                {[t('pg.UngdomsakademiPage.bb9891'), t('pg.UngdomsakademiPage.b962c6'), t('pg.UngdomsakademiPage.32c373')].map(item => (
                  <li key={item} className="flex items-start gap-2 text-slate-600 dark:text-slate-300">
                    <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-bold text-slate-900 dark:text-white mb-2 flex items-center gap-2">
                <Zap className="w-5 h-5 text-green-500" /> {t('pg.UngdomsakademiPage.af0408')}
              </h3>
              <p className="text-slate-600 dark:text-slate-300 mb-3">{t('pg.UngdomsakademiPage.e1e22e')}</p>
              <ul className="space-y-2">
                {[t('pg.UngdomsakademiPage.126260'), 'er motiverte for utvikling over tid', t('pg.UngdomsakademiPage.5bdc0a')].map(item => (
                  <li key={item} className="flex items-start gap-2 text-slate-600 dark:text-slate-300">
                    <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-bold text-slate-900 dark:text-white mb-2 flex items-center gap-2">
                <Award className="w-5 h-5 text-green-500" /> {t('pg.UngdomsakademiPage.2f0d42')}
              </h3>
              <p className="text-slate-600 dark:text-slate-300 mb-3">{t('pg.UngdomsakademiPage.e2a9fb')}</p>
              <ul className="space-y-2">
                {[t('pg.UngdomsakademiPage.7c5b32'), t('pg.UngdomsakademiPage.19b670'), t('pg.UngdomsakademiPage.85048b')].map(item => (
                  <li key={item} className="flex items-start gap-2 text-slate-600 dark:text-slate-300">
                    <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-bold text-slate-900 dark:text-white mb-2">{t('pg.UngdomsakademiPage.a81ff2')}</h3>
              <p className="text-2xl font-bold text-green-500">{t('pg.UngdomsakademiPage.ba1aaf')}</p>
              <p className="text-slate-500 dark:text-slate-400 text-sm">{t('pg.UngdomsakademiPage.aadfd6')}</p>
            </div>
          </div>
        </section>

        {/* Slik fungerer akademiet */}
        <section className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-8 mb-6">
          <h2 className="text-2xl font-bold text-slate-900 dark:text-white mb-6 flex items-center gap-2">
            <Clock className="w-6 h-6 text-green-500" /> {t('pg.UngdomsakademiPage.d2aafa')}
          </h2>

          <h3 className="text-lg font-bold text-slate-900 dark:text-white mb-2">{t('pg.UngdomsakademiPage.1faeb0')}</h3>
          <ul className="space-y-2 mb-6">
            <li className="flex items-start gap-2 text-slate-600 dark:text-slate-300">
              <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
              <span>{t('pg.UngdomsakademiPage.b4f328')}</span>
            </li>
            <li className="flex items-start gap-2 text-slate-600 dark:text-slate-300">
              <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
              <span>{t('pg.UngdomsakademiPage.6cc17a')} <em className="text-slate-500 dark:text-slate-400">{t('pg.UngdomsakademiPage.3896d9')}</em></span>
            </li>
            <li className="flex items-start gap-2 text-slate-600 dark:text-slate-300">
              <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
              <span>{t('pg.UngdomsakademiPage.e53427')}</span>
            </li>
            <li className="flex items-start gap-2 text-slate-600 dark:text-slate-300">
              <Snowflake className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
              <span>{t('pg.UngdomsakademiPage.166362')}</span>
            </li>
          </ul>

          <h3 className="text-lg font-bold text-slate-900 dark:text-white mb-2">{t('pg.UngdomsakademiPage.b9db3b')}</h3>
          <ul className="space-y-2">
            <li className="flex items-start gap-2 text-slate-600 dark:text-slate-300">
              <Users className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
              <span>{t('pg.UngdomsakademiPage.af8d7b')} <em className="text-slate-500 dark:text-slate-400">{t('pg.UngdomsakademiPage.a2b08d')}</em></span>
            </li>
            <li className="flex items-start gap-2 text-slate-600 dark:text-slate-300">
              <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
              <span>{t('pg.UngdomsakademiPage.58b7d6')}</span>
            </li>
            <li className="flex items-start gap-2 text-slate-600 dark:text-slate-300">
              <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
              <span>{t('pg.UngdomsakademiPage.32c373')}</span>
            </li>
          </ul>
          <p className="text-slate-600 dark:text-slate-300 mt-4 mb-2 font-medium">{t('pg.UngdomsakademiPage.7d3877')}</p>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
            {[t('pg.UngdomsakademiPage.27f8d3'), t('pg.UngdomsakademiPage.112026'), t('pg.UngdomsakademiPage.073c79'), t('pg.UngdomsakademiPage.c26582')].map(item => (
              <div key={item} className="bg-green-500/10 border border-green-500/30 rounded-lg p-3 text-center text-sm font-medium text-slate-700 dark:text-slate-200">
                {item}
              </div>
            ))}
          </div>
        </section>

        {/* Vintertrening */}
        <section className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-8 mb-6">
          <h2 className="text-2xl font-bold text-slate-900 dark:text-white mb-4 flex items-center gap-2">
            <Snowflake className="w-6 h-6 text-green-500" /> {t('pg.UngdomsakademiPage.c12afa')}
          </h2>
          <p className="text-slate-600 dark:text-slate-300">
            {t('pg.UngdomsakademiPage.2751d9')}
          </p>
        </section>

        {/* Eksempel på periodeplan */}
        <section className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-8 mb-6">
          <h2 className="text-2xl font-bold text-slate-900 dark:text-white mb-3">{t('pg.UngdomsakademiPage.f676be')}</h2>
          <p className="text-slate-600 dark:text-slate-300 mb-6">
            {t('pg.UngdomsakademiPage.c2cd91')} <a href="https://tiim.no" target="_blank" rel="noopener noreferrer" className="text-green-500 hover:underline">tiim.no</a>.
          </p>
          <div className="space-y-4">
            {getPeriodPlan().map(p => (
              <div key={p.num} className="flex gap-4 bg-slate-50 dark:bg-slate-700/40 rounded-lg p-4 border border-slate-200 dark:border-slate-700">
                <div className="w-10 h-10 bg-green-500 text-white rounded-full flex items-center justify-center font-bold flex-shrink-0">{p.num}</div>
                <div className="flex-1">
                  <div className="flex items-baseline justify-between gap-2 flex-wrap">
                    <h3 className="font-bold text-slate-900 dark:text-white">{p.title}</h3>
                    <span className="text-xs uppercase tracking-wider text-green-500 font-bold">{p.weeks}</span>
                  </div>
                  <p className="text-sm text-slate-600 dark:text-slate-300 mt-1">{p.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Praktisk info */}
        <section className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-8 mb-6">
          <h2 className="text-2xl font-bold text-slate-900 dark:text-white mb-4">{t('pg.UngdomsakademiPage.68c749')}</h2>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
            <div className="bg-green-500/10 border border-green-500/30 rounded-lg p-4">
              <p className="text-xs uppercase tracking-wider text-slate-500 dark:text-slate-400">{t('pg.UngdomsakademiPage.62f536')}</p>
              <p className="text-xl font-bold text-green-500 mt-1">4 000 kr</p>
              <p className="text-xs text-slate-400 dark:text-slate-500">{t('pg.UngdomsakademiPage.dc2883')}</p>
            </div>
            <div className="bg-green-500/10 border border-green-500/30 rounded-lg p-4">
              <p className="text-xs uppercase tracking-wider text-slate-500 dark:text-slate-400">{t('pg.UngdomsakademiPage.ac50c4')}</p>
              <p className="text-xl font-bold text-green-500 mt-1">Ca. 20</p>
            </div>
            <div className="bg-green-500/10 border border-green-500/30 rounded-lg p-4">
              <p className="text-xs uppercase tracking-wider text-slate-500 dark:text-slate-400">{t('pg.UngdomsakademiPage.9b017f')}</p>
              <p className="text-base font-bold text-green-500 mt-1">{t('pg.UngdomsakademiPage.47fecf')}</p>
            </div>
            <div className="bg-green-500/10 border border-green-500/30 rounded-lg p-4">
              <p className="text-xs uppercase tracking-wider text-slate-500 dark:text-slate-400">{t('pg.UngdomsakademiPage.7480aa')}</p>
              <p className="text-xl font-bold text-green-500 mt-1">{t('pg.UngdomsakademiPage.339433')}</p>
            </div>
          </div>
        </section>

        {/* Signup CTA */}
        <section className="bg-gradient-to-r from-green-500 to-green-600 rounded-2xl p-8 mb-6 text-center">
          <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3">{t('pg.UngdomsakademiPage.c8f79a')}</h2>
          <p className="text-white/90 mb-2 max-w-2xl mx-auto">
            {t('pg.UngdomsakademiPage.9d1bba')}<br />
            <strong>{t('pg.UngdomsakademiPage.0eb869')}</strong>
          </p>
          <p className="text-white/90 mb-6 text-sm">
            {t('pg.UngdomsakademiPage.29e4f4')}
          </p>
          <a href={SignupUrl} target="_blank" rel="noopener noreferrer" data-testid="ungdomsakademi-signup">
            <Button size="lg" className="bg-white text-green-700 hover:bg-slate-100 font-bold text-base px-8 py-6">
              {t('pg.UngdomsakademiPage.740798')}
              <ExternalLink className="ml-2 w-5 h-5" />
            </Button>
          </a>
          <p className="text-white/90 mt-6 italic">
            {t('pg.UngdomsakademiPage.767e6b')}
          </p>
        </section>

        {/* Kontakt */}
        <section className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-8">
          <h2 className="text-xl font-bold text-slate-900 dark:text-white mb-4">{t('pg.UngdomsakademiPage.8d1c6b')}</h2>
          <div className="space-y-2">
            <a href="mailto:fotballakademi@veitvet-sportsklubb.no" className="flex items-center gap-2 text-green-500 hover:underline">
              <Mail className="w-5 h-5" />
              fotballakademi@veitvet-sportsklubb.no
            </a>
            <a href="tel:+4790083520" className="flex items-center gap-2 text-green-500 hover:underline">
              <Phone className="w-5 h-5" />
              900 83 520
            </a>
          </div>
        </section>
      </div>
    </div>
  );
};

export default UngdomsakademiPage;
